export const CLAMPS_SIDE_LABEL = { front: "Front clamps only", rear: "Rear clamps only", both: "Front + rear clamps" };

export function clampsOnly(o) {
  return (o?.replacement_scope || "") === "clamps";
}

export function clampsSide(o) {
  const s = o?.replacement_clamps_side || "both";
  return CLAMPS_SIDE_LABEL[s] ? s : "both";
}

export function clampsLabel(o) {
  const s = clampsSide(o);
  return `${s === "both" ? 4 : 2} × ${s === "both" ? "front + rear" : s} clamps`;
}

export function clampCountExpected(o) {
  const s = clampsSide(o);
  return s === "both" ? "4 pcs · front + rear" : `2 pcs · ${s} pair`;
}

// Checklist steps for an order: clamps-only warranty → reduced list (no covers, no own box);
// otherwise the stage list minus the FF / RR skipped side.
export function packingFieldsFor(o, base) {
  if (clampsOnly(o)) {
    const s = clampsSide(o);
    return ["po_cat", ...(s !== "rear" ? ["f_clamp"] : []), ...(s !== "front" ? ["r_clamp"] : []), "clamp_count", "quality", "clamp_label", "picture_to_drive", "ships_with"];
  }
  const fs = String(o?.front_cover_code || "").trim().toUpperCase() === "FF";
  const rs = String(o?.rear_cover_code || "").trim().toUpperCase() === "RR";
  return (base || []).filter((f) => !(fs && (f === "front_cover" || f === "f_clamp"))).filter((f) => !(rs && (f === "rear_cover" || f === "r_clamp")));
}

export const EXTRA_STEP_META = {
  clamp_count: { title: "Clamp count", question: "Count the clamps — does the number match?" },
  ships_with: { title: "Ships inside box of", question: "These clamps have no box of their own — pick the order whose box they travel in." },
};
